import React from 'react';
import { CssBaseline } from '@mui/material';
import { ApolloProvider } from '@apollo/client';
import { Provider } from 'react-redux';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { HelmetProvider } from 'react-helmet-async';

import { SnackbarContainer } from '@occc-app/design-system';
import { apolloClient } from '@occc-app/apollo/apolloClient';

import App from './App';
import Router from './router';

import { initialize as initializeGA, recordPageView } from '../lib/GoogleAnalytics';
import { ThemeContainer } from '../themes/ThemesContainer';
import { configureStore } from '../rootRedux/store';

initializeGA();
const store = configureStore();

const AppContainer = () => (
  <HelmetProvider>
    <ApolloProvider client={apolloClient}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Provider store={store}>
          <ThemeContainer>
            <Router onUpdate={recordPageView}>
              <CssBaseline />
              <SnackbarContainer />
              <App />
            </Router>
          </ThemeContainer>
        </Provider>
      </LocalizationProvider>
    </ApolloProvider>
  </HelmetProvider>
);

export default AppContainer;
